import { useEffect } from 'react';
import { useLoader } from 'src/provider/LoaderProvider';

/**
 * Shows the app-wide loader while any of the given flags is true and hides it otherwise. It
 * re-applies whenever one of the flags changes, even if the combined result stays the same.
 */
export const useLoaderWhile = (...isLoadingFlags: boolean[]): void => {
  const loader = useLoader();

  useEffect(() => {
    if (isLoadingFlags.some(Boolean)) {
      loader.show();
    } else {
      loader.hide();
    }
  }, isLoadingFlags);
};
